import React from 'react';
import { HiOutlineChartBar, HiOutlineUserGroup, HiOutlineLightningBolt, HiOutlineBell } from 'react-icons/hi';
import type { IconType } from 'react-icons';
import './Stats.css';

const IconWrapper: React.FC<{ Icon: IconType; color: string }> = ({ Icon, color }) => {
  const IconComponent = Icon as any;
  return <IconComponent style={{ color }} />;
};

interface Stat {
  value: string;
  label: string;
  Icon: IconType;
  color: string;
}

const stats: Stat[] = [
  {
    value: '10k+',
    label: 'PRs analisados',
    Icon: HiOutlineChartBar,
    color: 'var(--chart-1)'
  },
  {
    value: '500+',
    label: 'Times confiam',
    Icon: HiOutlineUserGroup,
    color: 'var(--chart-2)'
  },
  {
    value: '99.9%',
    label: 'Uptime',
    Icon: HiOutlineLightningBolt,
    color: 'var(--chart-3)'
  },
  {
    value: '24/7',
    label: 'Monitoramento',
    Icon: HiOutlineBell,
    color: 'var(--chart-4)'
  }
];

export const Stats: React.FC = () => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                <IconWrapper Icon={stat.Icon} color={stat.color} />
              </div>
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

